'use client';
import InfoCircle from '@/app/_components/ui/icons/InfoCircle.svg';
import Plus from '@/app/_components/ui/icons/Plus.svg';
import Minus from '@/app/_components/ui/icons/Minus.svg';
import ArrowLeft from '@/app/_components/ui/icons/ArrowLeft.svg';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import useCart from '@/app/_hooks/useCart';
import LoadingIcon from '../share/LoadingIcon';
import SpInformCustomer from './SpInformCustomer';
import { useProductContext } from '@/app/_providers/ProductContext';
import AddToInvoiceButton from './AddToInvoiceButton';

export default function SpAddToCartButton({ product, userToken }) {
  const { addToCart, cart, removeFromCart } = useCart();
  const [existInCart, setExistInCart] = useState(false);
  const [existItem, setExistItem] = useState(null);
  const { currentVariation } = useProductContext();
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  // // check if item existing in cart *****************************
  useEffect(() => {
    if (cart && cart.items) {
      const existingItem = cart.items.find(
        (item) => item.price_id === currentVariation?.id
      );
      if (existingItem) {
        setExistInCart(true);
        setExistItem(existingItem.number);
      } else {
        setExistInCart(false);
        setExistItem(null);
      }
    }
  }, [cart, currentVariation]);
  // add to cart product ************************************************
  const addToCartHandler = async () => {
    // dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    // dataLayer.push({
    //   event: 'add_to_cart',
    //   ecommerce: {
    //     currency: 'IRR',
    //     value: product.sale,
    //     items: [
    //       {
    //         item_id: product.id,
    //         item_name: product.title,
    //         discount: product.regular - product.sale,
    //         item_brand: product.brand.title,
    //         item_list_id: 'single_product',
    //         item_list_name: 'single product',
    //         price: product.sale,
    //         quantity: 1,
    //       },
    //     ],
    //   },
    // });

    let newItem = {
      number: 1,
      price_id: currentVariation.id,
      variation: {
        product: {
          media: {
            thumb: product.media.thumb,
          },
          slug: product.slug,
          title: product.title,
        },
        regular: currentVariation.regular,
        sale: currentVariation.sale,
        stock: currentVariation.stock,
      },
    };
    try {
      setIsAddingToCart(true); // Set loading state to true
      await addToCart({ items: [newItem] });
    } finally {
      setIsAddingToCart(false); // Reset loading state after the addToCart action completes
    }
  };
  // Remove from  cart  ************************************************
  const removeFromCartHandler = async () => {
    removeFromCart(currentVariation.id, 1);

    // dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    // dataLayer.push({
    //   event: 'remove_from_cart',
    //   ecommerce: {
    //     currency: 'IRR',
    //     value: product.sale,
    //     items: [
    //       {
    //         item_id: product.id,
    //         item_name: product.title,
    //         discount: product.regular - product.sale,
    //         item_brand: product.brand.title,
    //         item_list_id: 'single_product',
    //         item_list_name: 'single product',
    //         price: product.sale,
    //         quantity: 1,
    //       },
    //     ],
    //   },
    // });
  };
  if (currentVariation && Object.keys(currentVariation).length > 0) {
    return (
      <div className="flex items-center">
        {product.offline || !currentVariation ? (
          <div className="flex-1">
            <div className="text-gray-200 flex rounded-xl ">
              <div>
                <InfoCircle fill="#737578" />
              </div>

              <p className="text-sm pr-2  leading-5">
                برای خرید محصولاتی که امکان فروش آنلاین ندارند میتوانید از طریق
                روش‌های زیر اقدام به خرید کنید
              </p>
            </div>
          </div>
        ) : (
          <div className="flex-1">
            {existInCart ? (
              <>
                <div className="flex">
                  <div className="flex ml-2 w-[105px] h-[44px] bg-color-primary text-white rounded-md justify-between p-1 items-center">
                    <button
                      className="increaseValue"
                      disabled={existItem >= currentVariation.stock}
                      onClick={addToCartHandler}
                    >
                      {existItem >= currentVariation.stock ? (
                        <>
                          <span className="text-xs text-white">حداکثر</span>
                        </>
                      ) : (
                        <>
                          <Plus stroke="#fff" />
                        </>
                      )}
                    </button>
                    <div>
                      <span className="font-bold text-base text-white">
                        {existItem}
                      </span>
                    </div>
                    <button
                      className="removeValue"
                      onClick={removeFromCartHandler}
                    >
                      <Minus stroke="#fff" />
                    </button>
                  </div>
                  <div className="whitespace-nowrap  font-bold flex items-center">
                    <Link
                      href="/checkout/cart"
                      className="pt-1 rounded-md text-color-primary text-sm  flex items-center font-bold justify-center"
                    >
                      {`مشاهده سبد خرید `}
                      <ArrowLeft fill="#026ccf" />
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                {currentVariation.stock != 0 ? (
                  <button
                    className={` customer-inform w-full hover:shadow-primary transition bg-color-primary text-white py-3 rounded-md text-sm SpAddTocartButton `}
                    onClick={addToCartHandler}
                    disabled={currentVariation.stock == 0 ? true : false}
                  >
                    {isAddingToCart ? <LoadingIcon /> : ' افزودن به سبد خرید'}
                  </button>
                ) : (
                  <SpInformCustomer
                    token={userToken}
                    id={currentVariation.id}
                  />
                )}
              </>
            )}
          </div>
        )}
        <AddToInvoiceButton
          currentVariationId={currentVariation.id}
          productId={product.id}
        />
      </div>
    );
  }
}
